// extracted by mini-css-extract-plugin
module.exports = {"newsAndStoriesTile":"NewsAndStoriesTile_newsAndStoriesTile__3b9ZK","heading":"NewsAndStoriesTile_heading__2EQbk","image":"NewsAndStoriesTile_image__Co4Tc"};